// ResizeObserver 修复插件
export const resizeObserverFix = {
  // eslint-disable-next-line no-unused-vars
  install(app) {
    // 在应用启动时修复 ResizeObserver 问题
    if (typeof window !== 'undefined') {
      // 保存原始的 ResizeObserver
      const OriginalResizeObserver = window.ResizeObserver
      
      // 创建安全的 ResizeObserver 包装器
      class SafeResizeObserver extends OriginalResizeObserver {
        constructor(callback) {
          super((entries, observer) => {
            try {
              // 使用 requestAnimationFrame 来延迟执行，避免循环
              requestAnimationFrame(() => {
                try {
                  callback(entries, observer)
                } catch (error) {
                  // 忽略 ResizeObserver 相关错误
                  if (!error.message || !error.message.includes('ResizeObserver')) {
                    console.error('ResizeObserver callback error:', error)
                  }
                }
              })
            } catch (error) {
              // 忽略构造函数错误
              if (!error.message || !error.message.includes('ResizeObserver')) {
                console.error('ResizeObserver constructor error:', error)
              }
            }
          })
        }
      }
      
      // 替换全局 ResizeObserver
      window.ResizeObserver = SafeResizeObserver
      
      // 修复控制台错误输出
      const originalError = console.error
      console.error = (...args) => {
        const message = args[0]
        if (typeof message === 'string' && 
            (message.includes('ResizeObserver loop completed with undelivered notifications') ||
             message.includes('ResizeObserver loop limit exceeded') ||
             message.includes('ResizeObserver'))) {
          return
        }
        originalError.apply(console, args)
      }
      
      // 修复控制台警告输出
      const originalWarn = console.warn
      console.warn = (...args) => {
        const message = args[0]
        if (typeof message === 'string' && 
            (message.includes('ResizeObserver') ||
             message.includes('component is not registered'))) {
          return
        }
        originalWarn.apply(console, args)
      }
      
      // 全局错误事件处理
      window.addEventListener('error', (event) => {
        if (event.message && event.message.includes('ResizeObserver')) {
          event.preventDefault()
          return false
        }
      })
      
      // Promise 拒绝处理
      window.addEventListener('unhandledrejection', (event) => {
        if (event.reason && event.reason.message && 
            event.reason.message.includes('ResizeObserver')) {
          event.preventDefault()
          return false
        }
      })
      
      // 添加启动日志
      console.log('🔧 ResizeObserver 修复插件已加载')
    }
  }
} 